import { systemTexts } from 'constants/localization';

import {
  EOfferFormatKey,
  EQuantityFieldControl,
  ETimeAbbreviationStyle,
  ETimeBaseUnit,
  INumberFormatEntry,
  IQuantityFieldDescriptor,
  IQuantityFormat,
  IQuantityFormatSection,
  IStoreSettingsFormValues,
  ITimeFormat
} from './StoreSettings.types';

const defaultQuantityFormat: IQuantityFormat = {
  milSeparator: ',',
  fractionalSeparator: '.',
  thousandShorthand: false,
  millionShorthand: false,
  billionShorthand: false,
  trillionShorthand: false,
  quadrillionShorthand: false,
  quintillionShorthand: false,
  sextillionShorthand: false,
  septillionShorthand: false,
  digitsBasedAbbreviation: false,
  maxDigitsWithoutShorthand: 3
};

const defaultTimeFormat: ITimeFormat = {
  baseUnitThreshold: 72,
  baseUnit: ETimeBaseUnit.HOURS,
  abbreviationStyle: ETimeAbbreviationStyle.SHORT
};

const buildDefaultNumberFormatEntry = (): INumberFormatEntry => ({
  quantity: { ...defaultQuantityFormat },
  time: { ...defaultTimeFormat }
});

export const defaultStoreSettings: IStoreSettingsFormValues = {
  numberFormat: {
    [EOfferFormatKey.PRODUCTS]: buildDefaultNumberFormatEntry(),
    [EOfferFormatKey.BALANCE]: buildDefaultNumberFormatEntry(),
    [EOfferFormatKey.SPECIAL_OFFER]: buildDefaultNumberFormatEntry(),
    [EOfferFormatKey.ROLLING_OFFER]: buildDefaultNumberFormatEntry(),
    [EOfferFormatKey.PROGRESS_BAR]: buildDefaultNumberFormatEntry(),
    [EOfferFormatKey.TRIGGERED_POPUP]: buildDefaultNumberFormatEntry()
  }
};

export const QUANTITY_FORMAT_SECTIONS: IQuantityFormatSection[] = [
  {
    key: EOfferFormatKey.PRODUCTS,
    title: systemTexts.settingsTexts.TITLES.BUNDLE_QUANTITY_FORMAT
  },
  {
    key: EOfferFormatKey.BALANCE,
    title: systemTexts.settingsTexts.TITLES.BALANCE_QUANTITY_FORMAT
  },
  {
    key: EOfferFormatKey.SPECIAL_OFFER,
    title: systemTexts.settingsTexts.TITLES.SPECIAL_OFFER_QUANTITY_FORMAT
  },
  {
    key: EOfferFormatKey.ROLLING_OFFER,
    title: systemTexts.settingsTexts.TITLES.ROLLING_OFFER_QUANTITY_FORMAT
  }
];

export const QUANTITY_FORMAT_FIELDS: IQuantityFieldDescriptor[] = [
  {
    key: 'milSeparator',
    header: 'Thousands separator',
    control: EQuantityFieldControl.SEPARATOR,
    gridSize: 6
  },
  {
    key: 'fractionalSeparator',
    header: 'Decimal separator',
    control: EQuantityFieldControl.SEPARATOR,
    gridSize: 6
  },
  {
    key: 'thousandShorthand',
    header: 'Abbreviate thousands (K)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'millionShorthand',
    header: 'Abbreviate millions (M)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'billionShorthand',
    header: 'Abbreviate billions (B)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'trillionShorthand',
    header: 'Abbreviate trillions (T)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'quadrillionShorthand',
    header: 'Abbreviate quadrillions (Q)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'quintillionShorthand',
    header: 'Abbreviate quintillions (Qi)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'digitsBasedAbbreviation',
    header: 'Digits based abbreviation',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 6
  },
  {
    key: 'maxDigitsWithoutShorthand',
    header: 'Max digits without shorthand',
    control: EQuantityFieldControl.NUMBER,
    gridSize: 6
  }
];
